const indexItems = [
  { title: '热血漫画', count: '326部', desc: '高燃战斗，激情澎湃的热血冒险故事', icon: 'ri-fire-line', color: 'primary' },
  { title: '恋爱漫画', count: '258部', desc: '甜蜜浪漫，心跳加速的恋爱物语', icon: 'ri-heart-line', color: 'accent' },
  { title: '悬疑漫画', count: '183部', desc: '烧脑推理，扣人心弦的悬疑剧场', icon: 'ri-search-eye-line', color: 'secondary' },
  { title: '奇幻漫画', count: '215部', desc: '异世界冒险，天马行空的奇幻旅程', icon: 'ri-magic-line', color: 'primary' },
  { title: '惊悚漫画', count: '142部', desc: '紧张刺激，深夜必看的惊悚故事', icon: 'ri-ghost-line', color: 'accent' },
  { title: '搞笑漫画', count: '198部', desc: '轻松愉快，笑到停不下来的日常喜剧', icon: 'ri-emotion-laugh-line', color: 'secondary' },
  { title: '古风漫画', count: '167部', desc: '唯美古韵，穿越时空的古典传奇', icon: 'ri-landscape-line', color: 'primary' },
];

export default function IndexSection() {
  const colorMap: Record<string, { bg: string; text: string; icon: string }> = {
    primary: { bg: 'bg-primary-100', text: 'text-primary-600', icon: 'text-primary-500' },
    accent: { bg: 'bg-accent-100', text: 'text-accent-600', icon: 'text-accent-500' },
    secondary: { bg: 'bg-secondary-100', text: 'text-secondary-600', icon: 'text-secondary-500' },
  };

  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-10">
          主题索引
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item, i) => {
            const c = colorMap[item.color];
            return (
              <div
                key={i}
                className={`group p-5 rounded-xl border border-background-200/70 hover:border-${item.color === 'primary' ? 'primary' : item.color === 'accent' ? 'accent' : 'secondary'}-300/60 bg-background-100 hover:bg-background-50 transition-all duration-300 cursor-pointer ${i === 0 ? 'lg:col-span-2 lg:row-span-2' : ''}`}
              >
                {i === 0 ? (
                  <div className="flex flex-col h-full">
                    <div className={`w-14 h-14 rounded-2xl ${c.bg} flex items-center justify-center mb-4`}>
                      <i className={`${item.icon} text-2xl ${c.icon}`}></i>
                    </div>
                    <div className="flex items-center gap-3 mb-2">
                      <h3 className="text-lg font-heading text-foreground-900 group-hover:text-primary-500 transition-colors">
                        {item.title}
                      </h3>
                      <span className="px-2 py-0.5 rounded-md bg-primary-100 text-primary-600 text-xs font-medium whitespace-nowrap">
                        {item.count}
                      </span>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mt-auto">{item.desc}</p>
                  </div>
                ) : (
                  <>
                    <div className={`w-10 h-10 rounded-xl ${c.bg} flex items-center justify-center mb-3`}>
                      <i className={`${item.icon} text-lg ${c.icon}`}></i>
                    </div>
                    <div className="flex items-center gap-2 mb-1">
                      <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors">
                        {item.title}
                      </h3>
                      <span className="text-xs text-foreground-500">{item.count}</span>
                    </div>
                    <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}